import React, { useEffect, useState, useRef } from 'react';
import { ArrowDownAZ, ArrowUpAZ, Trash2, X, Pen, History } from 'lucide-react';
import NavBar, { loadNav } from '../../visualComponents/NavBarDev';
import * as XLSX from 'xlsx';
import Loader from '../../visualComponents/Loader.js';
import Tooltip from "../../components/Tooltip.js";


let isLoading = false;

const PopUpDominio = ({ isVisible, setIsVisible, codiceDominio }) => {
    const [infoDominio, setInfoDominio] = useState({});
    const [isFirstTime, setIsFirstTime] = useState(true);
    useEffect(() => {
        const loadInfoDominio = async () => {
            try {
                isLoading = true;
                const response = await fetch('/getDominio', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ CodiceDominio: codiceDominio })
                });
                const data = await response.json();
                if (response.status === 500) {
                    alert(data.error);
                    console.log(data.error);
                    window.location.reload();
                }
                else {
                    isLoading = false;
                    setInfoDominio(data[0]);
                }
            } catch (error) {
                alert("Errore nel caricamento delle informazioni del dominio, riprova più tardi.");
                console.error(error);
            }
        };
        if (isFirstTime && isVisible) {
            loadInfoDominio();
            setIsFirstTime(false);
        }
    }, [isVisible]);

    const closeModal = () => {
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-100 max-w-[90vw] text-black dark:text-white">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-bold">Dominio</h2>
                    <Tooltip content="Chiudi" >
                        <button className="text-red-500" onClick={closeModal}>
                            <X size={24} />
                        </button>
                    </Tooltip>

                </div>
                <div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">Codice/P.IVA: </p>
                        <p className="rounded w-full bg-white dark:bg-gray-800">{infoDominio["CodiceDominio"]}</p>
                    </div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">Indirizzo: </p>
                        <p className="rounded w-full bg-white dark:bg-gray-800">{infoDominio["Indirizzo"]}</p>
                    </div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">CAP: </p>
                        <p className="rounded w-full bg-white dark:bg-gray-800">{infoDominio["Cap"]}</p>
                    </div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">Città: </p>
                        <p className="rounded w-full bg-white dark:bg-gray-800">{infoDominio["Citta"]}</p>
                    </div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">Provincia: </p>
                        <p className="rounded w-full bg-white dark:bg-gray-800">{infoDominio["Provincia"]}</p>
                    </div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">Ragione Sociale: </p>
                        <p className="rounded w-full bg-white dark:bg-gray-800">{infoDominio["RagioneSociale"]}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

const PopUpLicenza = ({ isVisible, setIsVisible, piani, data }) => {
    const [quantita, setQuantita] = useState(0);
    const [piano, setPiano] = useState(1);
    const [validita, setValidita] = useState(0);
    const [venditore, setVenditore] = useState("");
    const inputRefs = useRef([]);

    useEffect(() => {
        if (isVisible && data) {
            resetData();
            const select = document.getElementById("licenza");
            select.value = data.IDPiano;
        }
    }, [isVisible]);

    const closeModal = () => {
        resetData();
        setIsVisible(false);
    };

    const resetData = () => {
        setQuantita(0);
        setPiano(data ? data.IDPiano : 1);
        setValidita(data ? data.ValiditaMesi : 0);
        setVenditore(data ? data.Venditore : "");
    };


    const handleConferma = async () => {
        if (data) {
            if (piano === 0 || validita === 0 || venditore === "") {
                alert("Inserire tutti i campi");
                return;
            };

            try {
                isLoading = true;
                const response = await fetch('/aggiornaLicenza', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ ID: data.ID, Piano: Number(piano), Validita: Number(validita), Venditore: venditore })
                });

                if (response.status === 500) {
                    const data = await response.json();
                    alert(data.message);
                    console.log(data.message);
                } else {
                    isLoading = false;
                    window.location.reload(true);
                }
            } catch (error) {
                alert("Errore nell'aggiornamento della licenza, riprova più tardi.");
                console.error(error);
                window.location.reload(true);
            }
        }
        else {
            if (quantita === 0 || piano === 0 || validita === 0 || venditore === "") {
                alert("Inserire tutti i campi");
                return;
            };

            try {
                isLoading = true;
                const response = await fetch('/addLicenza', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ Quantita: Number(quantita), Piano: Number(piano), Validita: Number(validita), Venditore: venditore })
                });
                if (response.status === 500) {
                    const data = await response.json();
                    alert(data.message);
                    console.log(data.message);
                } else {
                    isLoading = false;
                    window.location.reload(true);
                }
                closeModal();
                window.location.reload(true);
            } catch (error) {
                console.error(error);
            }
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Enter") {
            e.preventDefault(); // Evita il comportamento predefinito del form
            const nextInput = inputRefs.current[index + 1];
            if (nextInput) {
                nextInput.focus(); // Passa al campo successivo
            }
        }
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 text-black dark:text-white rounded-lg p-6 w-100 max-w-[90vw]">
                <div className="flex justify-center items-center mb-">
                    <h2 className="text-xl font-bold justify-self-center">{data ? "Modifica Licenza" : "Aggiungi Licenza"}</h2>
                </div>
                <div>
                    {
                        !data ? (
                            <>
                                <div className="grid grid-cols-2 mx-5 mb-2 mt-4">
                                    <p className="">Quantità: </p>
                                    <input
                                        type="number"
                                        className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                                        onChange={(e) => setQuantita(e.target.value)}
                                        onKeyDown={(e) => handleKeyDown(e, 0)}
                                        ref={(el) => inputRefs.current[0] = el}
                                    />
                                </div>
                            </>
                        ) : null
                    }

                    <div className="grid grid-cols-2 mx-5 mb-2">
                        <p className="">Piano: </p>
                        <select
                            id="licenza"
                            className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                            onChange={(e) => setPiano(e.target.value)}
                            onKeyDown={(e) => handleKeyDown(e, 1)}
                            ref={(el) => inputRefs.current[1] = el}
                        >
                            {
                                piani.map((p, index) => (
                                    <option key={index} value={p.ID}>{p.Nome} - {p.Descrizione}</option>
                                ))
                            }
                        </select>
                    </div>
                    <div className="grid grid-cols-2 mx-5 mb-2">
                        <p className="">Validità: (mesi) </p>
                        <input
                            type="number"
                            className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                            onChange={(e) => setValidita(e.target.value)}
                            value={validita}
                            onKeyDown={(e) => handleKeyDown(e, 2)}
                            ref={(el) => inputRefs.current[2] = el}
                        />
                    </div>
                    <div className="grid grid-cols-2 mx-5 mb-2">
                        <p className="">Venditore: </p>
                        <input
                            type="text"
                            className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                            onChange={(e) => setVenditore(e.target.value)}
                            value={venditore}
                            onKeyDown={(e) => handleKeyDown(e, 3)}
                            ref={(el) => inputRefs.current[3] = el}
                        />
                    </div>
                </div>
                <div className='mt-3 grid grid-cols-2'>
                    <button
                        onClick={closeModal}
                        className="mr-1 rounded-lg py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-bold"
                    >
                        Annulla
                    </button>
                    <button
                        onClick={handleConferma}
                        className="ml-1 rounded-lg py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-bold"
                    >
                        Conferma
                    </button>
                </div>
            </div>
        </div>
    );
};

const TableRow = ({ data, check, onCheckChange, piani }) => {
    const [isPopUpLicenzaVisible, setIsPopUpLicenzaVisible] = useState(false);
    const [isPopUpDominioVisible, setIsPopUpDominioVisible] = useState(false);

    const handleElimina = async () => {
        if (!window.confirm("Sei sicuro di voler eliminare questa licenza?")) return;
        try {
            isLoading = true;
            const response = await fetch('/eliminaLicenza', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ ID: data.ID })
            });

            if (response.status === 200) {
                isLoading = false;
                window.location.reload(true);
            }
            else {
                const data = await response.json();
                alert(data.message);
                console.log(data.message);
            }
        } catch (error) {
            alert("Operazione fallita, riprova più tardi.");
            console.log(error);
        }

    };

    return (
        <div className="grid grid-cols-9 gap-1 mt-2">
            <div className='flex items-center justify-end gap-4'>
                <input id={data[0]} type="checkbox" className='w-5 h-5 bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1' checked={check} onChange={onCheckChange} />
            </div>
            <div id={data.ID} className="col-span-7 bg-gray-300 dark:bg-gray-500 divide-x divide-black dark:divide-white rounded-lg grid grid-cols-7 p-4 text-center break-words flex items-center">
                <div>{data.CodiceAttivazione}</div>
                <div>{piani.find((d) => d.ID === data.IDPiano)?.Nome}</div>
                <div>{data.ValiditaMesi}</div>
                <div>{data.Venditore}</div>
                <div>{data.DataCreazione}</div>
                <div>{data.DataAttivazione === null ? ("------") : (data.DataAttivazione)}</div>
                {data.CodiceDominio === null ? (<div>------</div>) : (<div className='text-blue-500 cursor-pointer' onClick={() => setIsPopUpDominioVisible(true)}><u>{data.CodiceDominio}</u></div>)}
            </div>

            <div className="flex items-center gap-1 ">
                {data.Obsoleta === false ? (
                    <>
                        <Tooltip content="Modifica">
                            <button className="text-blue-500" onClick={() => setIsPopUpLicenzaVisible(true)}>
                                <Pen size={24} />
                            </button>
                        </Tooltip>

                        <Tooltip content="Elimina">
                            <button className="text-red-500" onClick={handleElimina}>
                                <Trash2 size={24} />
                            </button>
                        </Tooltip>
                    </>
                ) : null
                }
            </div>
            <PopUpLicenza isVisible={isPopUpLicenzaVisible} setIsVisible={setIsPopUpLicenzaVisible} piani={piani} data={data} />
            <PopUpDominio isVisible={isPopUpDominioVisible} setIsVisible={setIsPopUpDominioVisible} codiceDominio={data.CodiceDominio} />
        </div>
    );
};

const DashDev = () => {
    const [indexTabella, setIndexTabella] = useState([
        { value: "Codice", dbCode: "CodiceAttivazione", ascending: true, filter: "text" },
        { value: "Piano", dbCode: "IDPiano", ascending: true, filter: "text" },
        { value: "Validità (mesi)", dbCode: "ValiditaMesi", ascending: true, filter: "number" },
        { value: "Venditore", dbCode: "Venditore", ascending: true, filter: "text" },
        { value: "Data Creazione", dbCode: "DataCreazione", ascending: true, filter: "text" },
        { value: "Data Attivazione", dbCode: "DataAttivazione", ascending: true, filter: "text" },
        { value: "Dominio", dbCode: "CodiceDominio", ascending: true, filter: "text" }
    ]);
    const [filters, setFilters] = useState({
        CodiceAttivazione: "",
        IDPiano: "",
        ValiditaMesi: "",
        Venditore: "",
        DataCreazione: "",
        DataAttivazione: "",
        CodiceDominio: ""
    });
    const [data, setData] = useState([]);
    const [viewData, setViewData] = useState([]);
    const [piani, setPiani] = useState([]);
    const [isPopUpVisible, setIsPopUpVisible] = useState(false);
    const [archive, setArchive] = useState(false);

    useEffect(() => {
        loadNav();
        loadPiani();
        loadDati();
    }, []);

    useEffect(() => {
        setViewData(data.filter((d) => d.value["Obsoleta"] === archive));
    }, [data]);

    useEffect(() => {
        let newData = [...data];
        for (const key in filters) {
            if (filters[key] !== "") {
                if (key === "IDPiano") {
                    newData = newData.filter((d) => (d.value[key] !== null ? piani.find((p) => p.ID === d.value[key]).Nome.toLowerCase().includes(filters[key].toLowerCase()) : null));
                } else {
                    newData = newData.filter((d) => (d.value[key] !== null ? d.value[key].toString().toLowerCase().includes(filters[key].toLowerCase()) : null));
                }
            }
        };
        setViewData(newData.filter((d) => d.value["Obsoleta"] === archive));
    }, [filters]);

    const loadPiani = async () => {
        try {
            isLoading = true;
            const response = await fetch('/getPiani', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            if (response.status === 500) {
                alert(data.error);
                console.log(data.error);
                window.location.reload();
            }
            else {
                isLoading = false;
                setPiani(data);
            }
        } catch (error) {
            alert("Errore nel caricamento dei piani, riprova più tardi.");
            console.error(error);
        }
    };

    const loadDati = async () => {
        try {
            isLoading = true;
            const response = await fetch('/getLicenze', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const responseData = await response.json();
            if (response.status === 500) {
                alert(responseData.error);
                console.log(responseData.error);
                window.location.reload();
            }
            else {
                isLoading = false;
                setData(responseData.map(item => ({ value: item, checked: false })));
            }
        } catch (error) {
            alert("Errore nel caricamento delle licenze, riprova più tardi.");
            console.error(error);
        }
    };

    const sortByColumn = (column) => {
        setIndexTabella((prevIndexTabella) =>
            prevIndexTabella.map((d) =>
                d.dbCode === column ? { ...d, ascending: !d.ascending } : d
            )
        );
        const isAscending = indexTabella.find((d) => d.dbCode === column)?.ascending;
        let newData = [...viewData];

        newData.sort((a, b) => {
            const valA = a.value[column];
            const valB = b.value[column];

            const isDateFormat = typeof valA === "string" && /^\d{2}\/\d{2}\/\d{4}$/.test(valA);

            if (isDateFormat) {
                const dateA = parseDate(valA);
                const dateB = parseDate(valB);
                return isAscending ? dateA - dateB : dateB - dateA;
            }

            if (valA > valB) return isAscending ? -1 : 1;
            if (valA < valB) return isAscending ? 1 : -1;
            return 0;
        });

        setViewData(newData);
    };

    const parseDate = (str) => {
        const [day, month, year] = str.split('/');
        return new Date(`${year}-${month}-${day}`);
    };

    const handleAdd = () => {
        setIsPopUpVisible(true);
    };

    const handleExport = () => {
        const dataChecked = viewData.filter((d) => d.checked);
        if (dataChecked.length === 0) return;

        const dataSheet = dataChecked.map(d => ({
            CodiceAttivazione: d.value["CodiceAttivazione"],
            Piano: piani.find((p) => p.ID === d.value["IDPiano"]).Nome,
            ValiditaMesi: d.value["ValiditaMesi"],
            Venditore: d.value["Venditore"],
            DataCreazione: d.value["DataCreazione"],
            DataAttivazione: d.value["DataAttivazione"],
            Dominio: d.value["CodiceDominio"]
        }));
        const worksheet = XLSX.utils.json_to_sheet(dataSheet);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Foglio1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "Export.xlsx";
        link.click();
        window.URL.revokeObjectURL(url);
    };

    const handleCheckTotale = () => {
        let checkTotale = document.getElementById("tot").checked;
        let newData = [...viewData];
        newData.forEach((d) => d.checked = checkTotale);
        setViewData(newData);
    };

    const handleCheckChange = (id) => {
        let newData = [...data];
        newData.forEach((d, index) => {
            if (d["value"]["ID"] === id) d.checked = !d.checked;
        });
        setData(newData);
    };

    const handleArchive = () => {
        const newArchive = !archive;
        setArchive(newArchive);
        let newData = [...data];
        newData = newData.filter((d) => d.value["Obsoleta"] === newArchive);
        setViewData(newData);
    };

    return (
        <div className='min-h-screen bg-white dark:bg-gray-800 text-black dark:text-white'>
            <NavBar page="HOME" />
            {isLoading && <Loader />}
            <div className='p-4'>
                <div className='flex justify-center'>
                    <button className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mt-14" onClick={handleAdd}>
                        Aggiungi Licenza
                    </button>
                </div>
                <div id="tabella">
                    <div className="grid grid-cols-9 gap-1 mt-4">
                        <div className='flex items-center justify-end gap-4'>
                            <input id="tot" type="checkbox" className='w-5 h-5' onChange={handleCheckTotale} />
                        </div>
                        <div className="col-span-7 bg-gray-400 dark:bg-gray-600 divide-x divide-black dark:divide-white rounded-lg grid grid-cols-7 p-4 font-bold text-center">
                            {
                                indexTabella.map((d, index) => (
                                    <div key={index} onClick={() => sortByColumn(d.dbCode)} className="hover:cursor-pointer grid grid-cols-1 md:flex md:items-center md:justify-center">
                                        <p className="text-[2vw] md:text-base flex items-center justify-self-center">{d.value}</p>
                                        <Tooltip content="Ordina">
                                        <button className="ml-2 text-gray-500 dark:text-gray-700 justify-self-center">
                                            {d.ascending ? <ArrowDownAZ size={24} /> : <ArrowUpAZ size={24} />}
                                        </button>
                                        </Tooltip>
                                    </div>
                                ))
                            }
                        </div>
                        <div></div>
                    </div>
                    <div className="grid grid-cols-9 gap-4 mt-2">
                        <div></div>
                        <div className="col-span-7 rounded-lg grid grid-cols-7 p-4 font-bold text-center divide-x divide-black dark:divide-white">
                            {
                                indexTabella.map((d, index) => (
                                    <div key={index} className={`flex items-center justify-center ${index === 0 ? "mr-2" : index === 6 ? "pl-2" : "px-2"}`}>
                                        <input
                                            type={d.filter}
                                            placeholder={d.value}
                                            value={filters[d.dbCode]}
                                            className={`text-[2vw] md:text-base rounded bg-gray-100 dark:bg-gray-300 border-2 border-gray-200 dark:border-gray-400 p-1 md:px-1 text-center w-full`}
                                            onChange={(e) => setFilters({ ...filters, [d.dbCode]: e.target.value })}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                        <div className='flex items-center'>
                            <Tooltip content="Archivio">
                                <button className={!archive ? "text-yellow-700" : "text-yellow-300"} onClick={handleArchive}>
                                    <History size={24} />
                                </button>
                            </Tooltip>
                        </div>
                    </div>
                    {viewData.map((d, index) => (
                        <TableRow key={index} data={d.value} check={d.checked} onCheckChange={() => handleCheckChange(d.value["ID"])} piani={piani} />
                    ))}
                </div>
                <div className='flex justify-center'>
                    <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4" onClick={handleExport}>
                        EXPORT
                    </button>
                </div>
                <PopUpLicenza isVisible={isPopUpVisible} setIsVisible={setIsPopUpVisible} piani={piani} />
            </div>
        </div>
    );
};

export default DashDev;